<template>
	<div class="agent-collapse">
		<!-- 折叠面板 -->
		<Collapse v-model="active" v-if="type=='collapse'">
			<Panel :name="value">
				<AgentTitle :title="title" :tips="tips" :red="red" />
				<slot name="content" slot="content"></slot>
			</Panel>
		</Collapse>
		<!-- 只有面板，不进行折叠 -->
		<div class="ivu-collapse" v-else>
			<div class="ivu-collapse-item">
				<div class="ivu-collapse-header" style="cursor:auto">
					<AgentTitle :title="title" :tips="tips" :red="red" />
				</div>
				<div class="ivu-collapse-content">
					<div class="ivu-collapse-content-box">
						<slot name="content"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import AgentTitle from './AgentTitle'
export default {
	components: {AgentTitle},
	props: {
		type: { // 默认折叠面板
			type: String,
			default:'collapse'
		},
		title:{
			type: String,
			default:'标题'
		},
		tips:{
			type: String,
			default:''
		},
		red: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			active: '1',
			value:'1'
		}
	},
	created () {
	},
	methods: {
		
	}
}
</script>
<style lang="less">
.agent-collapse{
	margin-bottom: 15px;
	.ivu-collapse>.ivu-collapse-item>.ivu-collapse-header{
		height: auto;
		padding-left: 15px;
		.ac-top{
			display: flex;
			align-items: center;
			.ac-title{
				font-size: 14px;
				font-weight: bold;
				margin-left: 12px;
				line-height: 20px;
				width:120px;
				position: relative;
				padding: 10px 0;
			}
			.ac-title.long{
				width:100%;
			}
			.ac-title::before{
				content: '';
				width: 5px;
				height: 15px;
				background: #2d8cf0;
				position: absolute;
				top: 12px;
				left: -12px;
			}
			.ac-tips{
				flex:1;
				font-size: 12px;
				line-height: 20px;
				margin: 10px 0;
    			margin-right: 40px;
			}
			.ac-tips.red{
				color: #ed4014;
			}
		}
	}
	.ivu-collapse-content{
		.item-content{
			font-size: 12px;
			.declare{
				p{
					margin: 0;
					line-height: 25px;
					padding-left: 23px;
					text-indent: -23px;
				}
				p.stress {
					font-weight: bold;
					margin-top: 10px;
				}
			}
		}
	} 
	.ivu-collapse>.ivu-collapse-item>.ivu-collapse-header>i {
		float: right;
		position: relative;
		top: 12px;
		right: 15px;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/agent/AgentCollapse.vue